import React from 'react'

const EventImpact = () => {
  return (
    <div>EventImpact</div>
  )
}

export default EventImpact